<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { usePwaUpdate, usePwaInstall } from '@/composables';

const { initPwaUpdate } = usePwaUpdate();
const { initPwaInstall } = usePwaInstall();

onMounted(() => {
  initPwaUpdate();
  initPwaInstall();
});
</script>
